// extracted by mini-css-extract-plugin
export default {"container":"ckHV4G","column":"GLWhGq","row":"DXT5mJ"};